import React from "react";
import AboutBanner from "../../components/about/aboutBanner";
import ExploreTUATARA from "../../components/about/exploreTUATARA";
import Inspiration from "../../components/about/inspiration";
import Values from "../../components/about/values";
import LetsWork from "../../components/about/letsWork";

export const AboutPage = () => {
  return (
    <div>
      <AboutBanner />
      <div className="bg-white">
        <ExploreTUATARA />
      </div>
      <div className="bg-[#F2F2F2]">
        <Inspiration />
      </div>
      <div className="bg-white">
        <div className="custom-container md:py-[125px] sm:py-[100px] py-[50px]">
          <div className="grid grid-cols-1 lg:grid-cols-2 lg:gap-[100px] gap-[20px]">
            <div>
              <div className="2xl:text-[36px] xl:text-[30px] lg:text-[25px] sm:text-[23px] text-[16px] text-[#000] text-[Roboto] font-bold py-[17px] lg:border-b-[5px] sm:border-b-[4px] border-b-[2px] border-[#7ABF5B] lg:w-[50%] md:w-[60%] sm:w-[70%] w-full">
                MISSION
              </div>
              <div className="font-[Roboto] font-normal 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[16px] text-[#000] mt-[20px]">
                The story of Tuatara began with a New Zealand native who recognized the need for a better utility
                vehicle—one that could take on tough jobs while remaining simple to operate and maintain. Initially
                serving local farmers, Tuatara quickly attracted attention from commercial industries and international
                buyers, leading to the creation of an innovative electric model that is now gaining significant market
                share
              </div>
            </div>
            <div>
              <div className="2xl:text-[36px] xl:text-[30px] lg:text-[25px] sm:text-[23px] text-[16px] text-[#000] text-[Roboto] font-bold py-[17px] lg:border-b-[5px] sm:border-b-[4px] border-b-[2px] border-[#7ABF5B] lg:w-[50%] md:w-[60%] sm:w-[70%] w-full">
                VISION
              </div>
              <div className="font-[Roboto] font-normal 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px]  text-[16px] text-[#000] mt-[20px]">
                The story of Tuatara began with a New Zealand native who recognized the need for a better utility
                vehicle—one that could take on tough jobs while remaining simple to operate and maintain. Initially
                serving local farmers, Tuatara quickly attracted attention from commercial industries and international
                buyers, leading to the creation of an innovative electric model that is now gaining significant market
                share
              </div>
            </div>
          </div>
        </div>
      </div>
      <Values />
      <div className="bg-white">
        <LetsWork />
      </div>
      {/* <div className="bg-[#F2F2F2]">
        <div className="custom-container md:px-[80px] px-[0px] md:py-[125px] sm:py-[100px] py-[50px]">
          <div className="font-[Rockwell] 2xl:text-[36px] xl:text-[30px] lg:text-[25px] sm:text-[23px] text-[16px] font-extrabold text-center">
            DISCOVER WAYS TO CONNECT
          </div>
          <div className="flex items-center justify-center mb-[90px] mt-[35px]">
            <div className="bg-[#7ABF5B] sm:h-[8px] h-[5px] sm:w-[350px] w-[150px]"></div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-x-[51px] gap-y-[30px]">
            <button
              className="w-full bg-[#7ABF5B] rounded font-[Roboto] 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#fff] lg:py-[22px] md:py-[18px] sm:py-[15px] py-[10px] font-bold my-[10px]"
              style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
            >
              FIND A DEALER
            </button>
            <button
              className="w-full bg-[#7ABF5B] rounded font-[Roboto] 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#fff] lg:py-[22px] md:py-[18px] sm:py-[15px] py-[10px] font-bold my-[10px]"
              style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
            >
              GET SOCIAL
            </button>
            <button
              className="w-full bg-[#7ABF5B] rounded font-[Roboto] 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#fff] lg:py-[22px] md:py-[18px] sm:py-[15px] py-[10px] font-bold my-[10px]"
              style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
            >
              CONTACT US
            </button>
          </div>
        </div>
      </div> */}
    </div>
  );
};
